export const DRAWER_ROLE = 'drawer';
export const SOURCE_FROM_DRAWER = 'search';
